export default function eachElement(selector, cb) {
	const elements = document.querySelectorAll(selector);

	if (elements) {
		Array.prototype.forEach.call(elements, element => {
			cb(element);
		});
	}
}
